import { AttendanceServiceEnum } from "../enums/attendance-cau.enum";

export class AttendanceDay {
    day: number;
    attendanceService: AttendanceServiceEnum;
    change: boolean;
    isHoliday: boolean;
  
    constructor(
      day: number,
      attendanceService: AttendanceServiceEnum,
      change: boolean,
      isHoliday
    ) {
      this.day = day;
      this.attendanceService = attendanceService;
      this.change = change;
      this.isHoliday = isHoliday;
    }
  }